import { useEffect } from 'react'
import background from 'assets/images/privacy-policy-background.png'
import Image from 'components/Image'
import { isServer } from 'data/helpers/ssr'
import PublicLayout, { PublicLayoutProps } from 'layouts/PublicLayout'
import { useHasScrolled } from 'data/hooks/useHasScrolled'

interface LegalInformationPageProps {
  seo: PublicLayoutProps['seo']
  title: string
  termlyId: string
}

const LegalInformationPage = ({
  seo,
  title,
  termlyId,
}: LegalInformationPageProps) => {
  const hasScrolled = useHasScrolled(0, true)

  useEffect(() => {
    (function (d, s, id) {
      // eslint-disable-next-line prefer-const
      let js, tjs = d.getElementsByTagName(s)[0]
      // eslint-disable-next-line prefer-const
      js = d.createElement(s); js.id = id
      // @ts-expect-error From a termly script
      js.src = 'https://app.termly.io/embed-policy.min.js'
      tjs.parentNode?.insertBefore(js, tjs)
    }(document, 'script', 'termly-jssdk'))

    return () => {
      const termlyScript = document.getElementById('termly-jssdk')
      if (termlyScript) {
        termlyScript.remove()
      }
    }
  }, [])

  return (
    <PublicLayout
      seo={seo}
      mobileNavBar={{
        visible: hasScrolled,
        back: true,
        profileTrigger: true,
      }}
    >

      <div className="relative flex h-full min-h-[375px] lg:min-h-[790px]">
        <Image
          src={background}
          alt="Tree overhanging a gateway into a Villa"
          className="absolute inset-0 object-cover"
          layout="fill"
          priority
        />
        <h1 className="absolute left-0 right-0 bottom-[44%] text-center text-white font-bold font-serif text-32 md:text-42 lg:text-48 xl:text-60 leading-title tracking-title drop-shadow-title">
          {title}
        </h1>
      </div>

      <div className="relative -mt-20 antialiased bg-white md:static container-public md:my-50 lg:my-75 rounded-t-20">
        {
          !isServer && (
            // @ts-expect-error From a termly script
            <div name="termly-embed" data-id={termlyId}></div>
          )
        }
      </div>
    </PublicLayout>
  )
}

export default LegalInformationPage
